import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidenavHeaderModule } from 'src/app/components/sidenav-header/sidenav-header.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { UpdateDefinitionComponent } from './update-definition.component';
import { MatDividerModule } from '@angular/material/divider';
import { SearchFilterModule } from 'src/app/components/search-filter/search-filter.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';



@NgModule({
  declarations: [
    UpdateDefinitionComponent
  ],
  exports: [
    UpdateDefinitionComponent
  ],
  imports: [
    CommonModule,
    SidenavHeaderModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    SearchFilterModule,
    PaginatorModule
  ]
})
export class UpdateDefinitionModule { }
